/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import { selectTheme } from "../styles";




const initialThemeState = selectTheme();


const themeReducer = ( state = initialThemeState, action ) => {
    switch (action.type) {
        case 'SET_THEME': {
            return action.theme || state;
        };
        case 'UPDATE_THEME': {
            return { ...state, ...action.colors };
        }
        default: {
            return state;
        }
    }
};



export { initialThemeState, themeReducer };